module.exports = __webpack_public_path__ + "img/characters_Nico.dfc17210.png";